import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import BadgeRow from './BadgeRow';

function Paw({ className = '', style }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width="80"
      height="80"
      className={`pointer-events-none ${className}`}
      style={style}
      fill="#B1F0F0"
      aria-hidden="true"
    >
      <ellipse cx="50" cy="65" rx="28" ry="22" />
      <circle cx="25" cy="35" r="12" />
      <circle cx="45" cy="25" r="12" />
      <circle cx="65" cy="25" r="12" />
      <circle cx="85" cy="35" r="12" />
    </svg>
  );
}

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-white overflow-hidden pt-24 pb-40">
      <Paw className="absolute top-16 left-1/6 rotate-[15deg]" />
      <Paw className="absolute top-[35%] right-1/12 -rotate-[20deg]" />
      <Paw className="absolute bottom-24 left-1/8 rotate-[5deg]" />

      <div className="container mx-auto px-6 text-center space-y-10">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {/* Mascot — mix-blend-mode multiply hides the black box on light bg */}
          <motion.img
            src="/images/nekochan-art-transparent.png"
            alt={t('finalCta.mascotAlt')}
            className="block mx-auto w-52 md:w-64 lg:w-80 drop-shadow-2xl select-none"
            draggable="false"
            whileHover={{ scale: 1.04, rotate: 1 }}
            transition={{ type: 'spring', stiffness: 200, damping: 15 }}
          />
        </motion.div>

        <h2 className="text-3xl md:text-5xl font-bold text-brand">
          {t('finalCta.headline')}
        </h2>
        <p className="max-w-2xl mx-auto text-lg text-gray-700">
          {t('finalCta.desc')}
        </p>

        {/* Single CTA → /download page */}
        <motion.a
          href="/download"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          className="inline-block bg-[#b13034] hover:bg-[#9a2a2d] text-white rounded-xl px-10 py-4 text-lg font-semibold shadow-lg transition-colors"
        >
          {t('finalCta.cta')}
        </motion.a>

        <BadgeRow className="justify-center pt-2 relative z-10" />
      </div>

      <svg
        className="absolute bottom-0 left-0 w-full translate-y-1 pointer-events-none"
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          d="M0 60c120 30 240 30 360 0s240-30 360 0 240 30 360 0 240-30 360 0v60H0Z"
          fill="#13C5C5"
        />
      </svg>
    </section>
  );
}
